import React from 'react'
import { Box, Modal, Typography, Button } from '@mui/material'
import { Warning, WarningAmber, WarningOutlined } from '@mui/icons-material'
import { teal, grey } from '@mui/material/colors'

const WarningModal = ({open, onClick, onClose, BackdropProps={ style: { backgroundColor: 'rgba(0, 0, 0, 0.1)' } }, sx, text, buttonText="Yes" }) => {
    
  return (
    <Modal open={open} onClose={onClose} BackdropProps={{ ...BackdropProps }}>
      <Box sx={{ ...sx }}>
        <WarningAmber sx={{color: teal[900], width: 0.4, height: 0.4, mb: 5}}/>
        <Typography sx={{color: grey[800], fontFamily: 'Segoe UI', fontWeight: 'bold', fontSize: {xs: 16, lg: 16}}}>
          {text}
        </Typography>
        <Box sx={{display:'flex', flexDirection: "column", mt: {xs: 2, lg: 5}}}>
          <Button variant='contained' onClick={onClick} disableElevation
            sx={{bgcolor: teal[900], ':hover': {bgcolor: teal[900]}, fontFamily: 'Segoe UI', borderRadius: {xs: 1, lg: 1}, textTransform: 'none', fontSize: {xs: 13, lg: 14}}}>
              {buttonText}
          </Button>
          <Button onClick={onClose}
            sx={{textTransform: 'none', color: grey[800], fontFamily: 'Segoe UI', fontWeight: 'bold', fontSize: {xs: 13, lg: 14}, mt: {xs: 1, lg: 1}}}>
              Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default WarningModal